import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { HELP_SECTION_ART_SIZE_POSITION, HELP_TOPIC_ART_SIZE_POSITION_STB_LINES } from '@app/constants';

import SvgIconUse from '@SvgIconUse';
import HelpTip from '@components/help/help-tip/HelpTip';

import RotateTool from '../tools/rotate-tool/RotateTool';
import MoveTool from '../tools/move-tool/MoveTool';
import ScaleTool from '../tools/scale-tool/ScaleTool';
import FitTool from '../tools/fit-tool/FitTool';
import Button from '@components/buttons/Button';

const PositionGroup = ({ toggleOverlay, visible, disabled, ...props }) => {
  const { current: moveArtLayout } = useRef(
      <div id='qau-toolgroup-position'>
        <ScaleTool />
        <div>
          <FitTool />
          <HelpTip
            tipLocKey='qau-safety-bleed-lines-text'
            helpSection={HELP_SECTION_ART_SIZE_POSITION}
            helpTopic={HELP_TOPIC_ART_SIZE_POSITION_STB_LINES}
          />
        </div>
        <RotateTool />
        <MoveTool />
      </div>,
    )
  ;

  return (
    visible && (
      <Button disabled={disabled} onClick={e => toggleOverlay(e, moveArtLayout)} {...props}>
        <SvgIconUse id='position' />
        <LocalizedText id='qau-toolgroup-position' tagName='span' />
      </Button>
    )
  );
};

PositionGroup.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default PositionGroup;
